export type ProductionPlanningStep = {
    stepId?: string;
    stepName: string;
    technicianId?: string;
    technicianName?: string;
    startDate: Date | null;
    deadline: Date | null;
    estimatedProductionHours?: number;
    estimatedMachineHours?: number;
    machineId?: string;
    stepOrder?: number;
    allowOvernight?: boolean;
    startNextDay?: boolean;
    affectedByQuantityModifier?: number;
    dayNumber?: number;
    workUnits?: number;
    departmentId?: string;
};

export enum AutoScheduleDirection {
    FORWARD_FROM_NOW = 'FORWARD_FROM_NOW',
    BACKWARD_FROM_DELIVERY = 'BACKWARD_FROM_DELIVERY',
}

export type AutoScheduleStepInput = {
    stepId: string;
    stepName: string;
    estimatedProductionHours: number;
    estimatedMachineHours?: number;
    allowOvernight?: boolean;
    startNextDay?: boolean;
    startDate?: Date | null;
    departmentId?: string;
    workUnits?: number;
};

export type CalculateStepHoursStepInput = {
    stepId: string;
    deadline: Date;
    startDate?: Date | null;
    estimatedMachineHours?: number;
};

export type CalculateStepHoursInput = {
    steps: CalculateStepHoursStepInput[];
    startDate?: Date | null;
};

export type AutoScheduleInput = {
    direction: AutoScheduleDirection;
    steps: AutoScheduleStepInput[];
    startDate?: Date | null;
    deliveryDate?: Date | null;
};

export type AutoScheduleStepResult = {
    stepId: string;
    startDate: string;
    deadline: string;
    dayNumber: number;
    estimatedProductionHours?: number;
};

export type CalculateStepHoursResult = {
    stepId: string;
    estimatedProductionHours: number;
};

export enum ChangedProperty {
    DEADLINE = 'DEADLINE',
    PRODUCTION_HOURS = 'PRODUCTION_HOURS',
    MACHINE_HOURS = 'MACHINE_HOURS',
    START_DATE = 'START_DATE',
    ALLOW_OVERNIGHT = 'ALLOW_OVERNIGHT',
    START_NEXT_DAY = 'START_NEXT_DAY',
}

export type UpdateStepWithCascadeInput = {
    steps: ProductionPlanningStep[];
    changedStepIndex: number;
    changedProperty: ChangedProperty;
};

export enum ScheduleStatus {
    ON_SCHEDULE = 'ON_SCHEDULE',
    LATE = 'LATE',
    EARLY = 'EARLY',
    PAUSED = 'PAUSED',
}

export type DepartmentCapacityEntry = {
    department: string;
    date: string;
    totalHours: number;
};

export type ScheduledStep = {
    orderId: string;
    orderDisplayId?: string;
    stepId: string;
    stepName: string;
    currentStepName?: string;
    workStarted?: boolean;
    isPaused?: boolean;
    pauseReason?: string;
    lastActionByName?: string;
    lastActionType?: string;
    department: string;
    technicianName?: string;
    startDate?: Date | null;
    deadline: Date;
    scheduleStatus: ScheduleStatus;
    estimatedProductionHours?: number;
    clinicName?: string;
    deliveryClinicName?: string;
    dentistName?: string;
    patientName?: string;
};
